export default __webpack_public_path__ + "static/N0024-fb6eb6893e8aff349888557d13a76ea9.png";